import React from 'react';
import Row from 'antd/lib/grid/row';
import Col from 'antd/lib/grid/col';
import css from '@emotion/css';
import { clone } from 'mobx-state-tree';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer, inject } from 'mobx-react';
import Input from '../../common/Input';
import {
  nameToUpperTwo,
  phoneCodes,
  upperThreeToTwo,
  upperTwoToName,
  upperTwoToThree,
} from '../../../constants/countries';
import { InfoContainer, InfoLabel } from './styled';
import CountriesDropdown from '../../common/CountriesDropdown/CountriesDropdown';
import { text3 } from '../../../constants/classes';
import { colors } from '../../../constants';

@inject('onboardingStore')
@observer
class BasicInfo extends React.Component {
  constructor(props) {
    super(props);
    const { country, phoneNumberCountryCode, phoneNumber, firstName, lastName } = clone(
      props.onboardingStore.userProfile,
    );
    this.state = {
      country: country ? upperTwoToThree[nameToUpperTwo[country]] : 'USA',
      phoneNumberCountryCode: phoneNumberCountryCode ? `+${phoneNumberCountryCode}` : 'USA',
      phoneNumber: phoneNumber || '',
      firstName: firstName || '',
      lastName: lastName || '',
      hasError: { phoneNumber: false, firstName: false, lastName: false },
      autoSwitched: false,
    };
  }

  componentDidMount() {
    // this.props.onboardingStore.setCountry(upperTwoToName[upperThreeToTwo[this.state.country]]);
    // this.props.onboardingStore.setPhoneNumberCountryCode(
    //   phoneCodes[upperThreeToTwo[this.state.phoneNumberCountryCode]],
    // );
    const {onboardingStore}=this.props;
    onboardingStore.setIsNonApi(false)
    if(!onboardingStore.userProfile.country){
      onboardingStore.setCountry(upperTwoToName[upperThreeToTwo.USA]);
    }
  }

  handleCountryCodeChange = value => {
    const { autoSwitched } = this.state;
    if (!autoSwitched) {
      this.setState({
        autoSwitched: true,
        country: value,
      });
      this.props.onboardingStore.setCountry(upperTwoToName[upperThreeToTwo[value]]);
    }
    this.props.onboardingStore.setPhoneNumberCountryCode(phoneCodes[upperThreeToTwo[value]]);
    this.setState({
      phoneNumberCountryCode: value,
    });
  };

  handleCountryChange = value => {
    const { autoSwitched } = this.state;
    if (!autoSwitched) {
      this.setState({
        autoSwitched: true,
        phoneNumberCountryCode: value,
      });
      this.props.onboardingStore.setPhoneNumberCountryCode(phoneCodes[upperThreeToTwo[value]]);
    }
    this.props.onboardingStore.setCountry(upperTwoToName[upperThreeToTwo[value]]);
    this.setState({
      country: value,
    });
  };

  handlePhoneNumberChange = e => {
    const { value } = e.target;
    const { hasError } = this.state;
    if (!value) {
      this.setState({
        phoneNumber: '',
        hasError: { ...hasError, phoneNumber: false },
      });
    } else if (/^\d+$/g.test(value)) {
      this.props.onboardingStore.setPhoneNumber(value);
      this.setState({
        phoneNumber: value,
        hasError: { ...hasError, phoneNumber: false },
      });
    } else {
      this.setState({
        phoneNumber: '',
        hasError: { ...hasError, phoneNumber: true },
      });
    }
  };

  handleFirstNameChange = e => {
    const { value } = e.target;
    const { hasError } = this.state;
    if (!value) {
      this.setState({
        firstName: '',
        hasError: { ...hasError, firstName: false },
      });
    } else if (
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(
        value,
      )
    ) {
      this.props.onboardingStore.setFirstName(value.trimStart());
      this.setState({
        firstName: value.trimStart(),
        hasError: { ...hasError, firstName: false },
      });
    } else {
      this.setState({
        firstName: '',
        hasError: { ...hasError, firstName: true },
      });
    }
  };

  handleLastNameChange = e => {
    const { value } = e.target;
    const { hasError } = this.state;
    if (!value) {
      this.setState({
        lastName: '',
        hasError: { ...hasError, lastName: false },
      });
    } else if (
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(
        value,
      )
    ) {
      this.props.onboardingStore.setLastName(value.trimStart());
      this.setState({
        lastName: value.trimStart(),
        hasError: { ...hasError, lastName: false },
      });
    } else {
      this.setState({
        lastName: '',
        hasError: { ...hasError, lastName: true },
      });
    }
  };

  validateFields = () => {
    const { country, phoneNumberCountryCode, phoneNumber, firstName, lastName } = this.state;
    return country && phoneNumberCountryCode && phoneNumber && firstName && lastName;
  };

  render() {
    const { onboardingStore } = this.props;
    const {
      hasError,
      phoneNumberCountryCode,
      country,
      firstName,
      lastName,
      phoneNumber,
    } = this.state;
    if (this.validateFields()) {
      onboardingStore.enableNextWizard();
    } else {
      onboardingStore.disableNextWizard();
    }

    return (
      <InfoContainer>
        <Row gutter={24} style={{ marginBottom: hasError.phoneNumber ? '0' : '32px' }}>
          <Col span={8}>
            <InfoLabel>
              <FormattedMessage id="common.phoneNumber" />
              {hasError.phoneNumber && (
                <span
                  css={css`
                    padding-top: 6px;
                    ${text3}
                    color: ${colors.pinkDark};
                  `}
                >
                  *
                </span>
              )}
            </InfoLabel>
          </Col>
          <Col span={16}>
            <CountriesDropdown
              width="100px"
              marginRight="7.5px"
              onChange={this.handleCountryCodeChange}
              value={phoneNumberCountryCode}
            />
            <Input onChange={this.handlePhoneNumberChange} width="53%" defaultValue={phoneNumber} />
          </Col>
        </Row>
        {hasError.phoneNumber && (
          <div
            css={css`
              height: 32px;
              ${text3}
              color: ${colors.pinkDark};
            `}
          >
            <FormattedMessage id="onboarding.screen3.invalidPhone" />
          </div>
        )}
        <Row gutter={24} style={{ marginBottom: '32px' }}>
          <Col span={8}>
            <InfoLabel>
              <FormattedMessage id="common.country" />
            </InfoLabel>
          </Col>
          <Col span={16}>
            <CountriesDropdown
              width="230px"
              showSearch
              onChange={this.handleCountryChange}
              css={css`
                & .ant-select-search__field__wrap > input {
                  border-radius: 0;
                }
              `}
              value={country}
              countryFormat="full"
              hideFlag
            />
          </Col>
        </Row>
        <Row gutter={24} style={{ marginBottom: hasError.firstName ? '0' : '32px' }}>
          <Col span={8}>
            <InfoLabel>
              <FormattedMessage id="userProfile.firstName" />
              {hasError.firstName && (
                <span
                  css={css`
                    padding-top: 6px;
                    ${text3}
                    color: ${colors.pinkDark};
                  `}
                >
                  *
                </span>
              )}
            </InfoLabel>
          </Col>
          <Col span={16}>
            <Input onChange={this.handleFirstNameChange} width="230px" defaultValue={firstName} />
          </Col>
        </Row>
        {hasError.firstName && (
          <div
            css={css`
              height: 32px;
              ${text3}
              color: ${colors.pinkDark};
            `}
          >
            <FormattedMessage id="onboarding.screen3.invalidFirstName" />
          </div>
        )}
        <Row gutter={24} style={{ marginBottom: hasError.lastName ? '0' : '32px' }}>
          <Col span={8}>
            <InfoLabel>
              <FormattedMessage id="userProfile.lastName" />
              {hasError.lastName && (
                <span
                  css={css`
                    padding-top: 6px;
                    ${text3}
                    color: ${colors.pinkDark};
                  `}
                >
                  *
                </span>
              )}
            </InfoLabel>
          </Col>
          <Col span={16}>
            <Input onChange={this.handleLastNameChange} width="230px" defaultValue={lastName} />
          </Col>
        </Row>
        {hasError.lastName && (
          <div
            css={css`
              height: 32px;
              ${text3}
              color: ${colors.pinkDark};
            `}
          >
            <FormattedMessage id="onboarding.screen3.invalidLastName" />
          </div>
        )}
      </InfoContainer>
    );
  }
}

BasicInfo.propTypes = {
  onboardingStore: PropTypes.object,
};

export default BasicInfo;
